import { FunctionComponent, PropsWithChildren } from "react"
import { Navigate, useLocation } from "react-router"

import AxiosInstanceProvider from "@/components/core/AxiosInstanceProvider"
import { CallStatusesProvider } from "@/hooks/call-statuses-context"

import { PageView } from "../Root/analytics"
import { ModalRoot } from "../Root/modal-root"
import { useProtectedRouteHook } from "./hook"

const ProtectedRoute: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { cognitoAuthStatus } = useProtectedRouteHook()
  const location = useLocation()

  // TODO: Add a loading spinner for the authenticating state
  if (cognitoAuthStatus.current === "AUTHENTICATING") {
    return <div>Authenticating...</div>
  }

  if (cognitoAuthStatus.current === "NOT_AUTHENTICATED") {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return (
    <AxiosInstanceProvider>
      <CallStatusesProvider>
        {children}
        {/* The modal needs access to the Axios client and the Statuses store */}
        <ModalRoot />
      </CallStatusesProvider>
      <PageView />
    </AxiosInstanceProvider>
  )
}

export default ProtectedRoute
